import {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Autoplay,
} from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import React from "react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/css/autoplay";

const DiversionBrasil = ({ hasBg = true }) => {
  return (
    <>
      <section
        id="diversion"
        className={`screenshots-section ptb-100 ${
          hasBg ? "gray-light-bg" : ""
        }`}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8">
              <div className="section-heading text-center">
                {hasBg ? (
                  <span className="text-uppercase color-secondary sub-title">
                    Playa ,fiesta y mas
                  </span>
                ) : (
                  ""
                )}
                <h2>¡ Brasil com Upgrade, é melhor!</h2>
                <p className="lead">
                  ¡Vivi la experiencia Upgrade en Brasil y disfruta de lo mejor
                  que este destino tiene para ofrecer! fiestas exclusivas y
                  emocionantes, excursiones inolvidables tanto de día como de
                  noche. Disfruta de las espectaculares playas de Camboriú y
                  crea recuerdos únicos en este paraíso tropical. ¡No te pierdas
                  la oportunidad de vivir tu viaje de egresados con Upgrade!
                </p>
              </div>
            </div>
          </div>
          <Swiper
            // install Swiper modules
            modules={[Autoplay, Navigation, Pagination, Scrollbar, A11y]}
            centeredSlides={true}
            spaceBetween={50}
            slidesPerView={1}
            autoplay={{
              delay: 2000,
              disableOnInteraction: false,
            }}
            // autoplay= {{delay: 2000}}
            loop={true}
            // navigation
            pagination={{ clickable: true }}
            // scrollbar={{ draggable: true }}
            onSwiper={(swiper) => console.log(swiper)}
            // onSlideChange={() => console.log('slide change')}
          >
            <SwiperSlide>
              <img
                src="assets/img/brasil/diversion/imagenbrasil1.jpg"
                alt="img"
                className="img-fluid"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="assets/img/brasil/diversion/imagenbrasil2.jpg"
                alt="img"
                className="img-fluid"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="assets/img/brasil/diversion/imagenbrasil3.jpg"
                alt="img"
                className="img-fluid"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="assets/img/brasil/diversion/imagenbrasil4.jpg"
                alt="img"
                className="img-fluid"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="assets/img/brasil/diversion/imagenbrasil5.jpg"
                alt="img"
                className="img-fluid"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="assets/img/brasil/diversion/imagenbrasil6.jpg"
                alt="img"
                className="img-fluid"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="assets/img/brasil/diversion/imagenbrasil7.jpg"
                alt="img"
                className="img-fluid"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="assets/img/brasil/diversion/imagenbrasil8.jpg"
                alt="img"
                className="img-fluid"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="assets/img/brasil/diversion/imagenbrasil9.jpg"
                alt="img"
                className="img-fluid"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="assets/img/brasil/diversion/imagenbrasil10.jpg"
                alt="img"
                className="img-fluid"
              />
            </SwiperSlide>
          </Swiper>
        </div>
      </section>
    </>
  );
};

export default DiversionBrasil;
